<template>
  <div class="container">
    <template v-if="!$store.state.isHiddenContainer">
      <!-- 顶部 -->
      <div class="head">
        <div class="left">
          <div class="pic">
            <img src="../src/assets/logo.png" />
          </div>
          <p>上海市绿色建筑协会会员系统</p>
        </div>
        <div class="right">
          <div class="head-pic">
            <div class="pic">
              <img src="../src/assets/img-head.png" />
            </div>
            <p id="username">{{this.username}}</p>
          </div>
          <div class="logout">
            <div class="pic">
              <img src="../src/assets/logout.png" />
            </div>
            <a href="javascript: 0" @click="logout">
              <p id="logout">注销登录</p>
            </a>
          </div>
        </div>
      </div>

      <!-- 侧边栏 -->
      <div class="aside" :key="defaultActive">
      <!-- 会员页面 -->
        <el-menu
          @select="selectItem"
          :default-active="defaultActive"
          background-color="#393D49"
          text-color="#fff"
          active-text-color="#fff"
          v-if="isMember"
        >
          <el-menu-item v-for="(route, index) in leftRoutes" :key="index" :index="route.leftMenu" @click="clickItem">
            <template slot="title">
              <img class="asideIcon" :src="route.icon" />
              {{ route.label}}
            </template>
          </el-menu-item>
        </el-menu>
         
        <!-- 非会员页面  -->
        <el-menu
          @select="selectNotMemberItem"
          :default-active="defaultActive"
          background-color="#393D49"
          text-color="#fff"
          active-text-color="#fff"
          v-else
        >
          <el-menu-item v-for="(item,index) in notMemberLeftRouters" :key="index" :index="item.leftMenu" @click="clickItem">
            <template>
              <img class="asideIcon" :src="item.icon" />
              {{item.label}}
            </template>
          </el-menu-item>
        </el-menu>

        <div class="asideContact">
          <img src="../src/assets/qrcode.png" />
          <span>扫一扫，关注我们</span>
          <p>邮政编码：200032</p>
          <p>联系电话：021-64083368</p>
          <p>传真号码：021-54249331</p>
          <p>联系地址：上海市宛平南路75号一号楼9楼</p>
        </div>
      </div>
      <!-- 内容主体区 -->
    </template>
    <router-view :key="activeDate" style="overflow-y: auto;" />
  </div>
</template>

<script>
import { leftRoutes, notMemberLeftRouters } from './router'
import * as Cache from './utils/cache'

export default {
  data () {
    return {
      leftRoutes,
      notMemberLeftRouters,
      activeDate: (new Date().getTime()).toString()
    }
  },
  computed: {
    defaultActive () {
      return this.$store.state.defaultActive
    },
    isMember () {
      return this.$store.state.memberInfo.memberno
    },
    username () {
      return this.$store.state.username
    }
  },
  methods: {
    selectItem (name) {
      const path = leftRoutes.find(item => item.leftMenu === name).path
      this.$router.push(path)
    },
    selectNotMemberItem (name) {
      const path = notMemberLeftRouters.find(item => item.leftMenu === name).path
      this.$router.push(path)
    },
    
    // 每次点击菜单都刷新当前路由
    clickItem () {
      this.activeDate = (new Date().getTime()).toString()
    },

    logout () {
      this.$confirm('确定退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Cache.clearUserInfo()
        this.$router.push('/login')
      })
    }
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
}
html,
body,
.container {
  width: 100%;
  height: 100%;
  background-color: #f7f7f7;
}
/* 顶部样式 */
.head {
  position: fixed;
  padding: 0 20px;
  z-index: 1000;
  width: 100%;
  height: 80px;
  background-image: url("../src/assets/head.png");
  background-size: cover;
  background-position: center center;
}
.head .left {
  float: left;
  margin-top: 19px;
}
.head .left .pic {
  float: left;
  width: 140px;
  height: 42px;
}
.head img {
  display: block;
  width: 100%;
  height: 100%;
}
.head .left p {
  float: left;
  font-size: 24px;
  color: #ffffff;
  line-height: 36px;
  margin-top: 6px;
  margin-left: 12px;
}
.head .right {
  float: right;
  margin-top: 24px;
}
.head .right .head-pic {
  float: left;
  margin-right: 50px;
}
.head .right .pic {
  float: left;
  width: 32px;
  height: 32px;
}
.head .right p {
  float: left;
  font-size: 14px;
  color: #ffffff;
  line-height: 32px;
  margin-left: 12px;
}
.head .right .logout {
  float: left;
  margin-top: 7px;
}
.head .right .logout .pic {
  float: left;
  width: 16px;
  height: 16px;
}
.head .right .logout p {
  line-height: 16px;
  cursor: pointer;
}
.head .right .logout p:hover {
  color: #afc7ff;
}

/* 侧边栏样式 */
.aside {
  margin-right: 10px;
  width: 240px !important;
  height: calc(100% - 90px);
  margin-top: 90px;
  background-color: #3a3f4a;
  border-top-right-radius: 8px;
  overflow-y: auto;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  overflow-x: hidden;
}
.el-menu {
  border: 0;
}
.el-menu-item.is-active {
  background-color: #00978a !important;
}
.asideIcon {
  width: 18px;
  margin-right: 10px;
}
.asideContact {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
}
.asideContact img {
  display: inline-block;
  width: 135px;
  margin-top: 6px;
  box-shadow: 0 2px 6px 1px rgba(138, 138, 138, 0.12);
}
.asideContact span {
  display: block;
  font-size: 12px;
  line-height: 24px;
  color: #ffffff;
  margin-bottom: 8px;
}
.asideContact p {
  font-size: 12px;
  line-height: 18px;
  text-align: left;
  color: #ffffff;
  margin-left: 8px;
  white-space: nowrap;
}

/* 内容区域样式 */
.main {
  position: relative;
  width: calc(100% - 250px);
  height: calc(100% - 90px);
  left: 250px;
  top: 90px;
}
.title {
  position: relative;
  margin-top: 0;
  margin-bottom: 20px;
  width: 99%;
  height: 50px;
  line-height: 50px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
}
.text {
  vertical-align: middle;
  margin-left: 20px;
  margin-right: 10px;
  font-size: 18px;
  color: #666666;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
}
.text > span {
  margin-left: 10px;
  font-size: 18px;
  color: #ababab;
}
.el-form-item__content {
  text-align: left;
}
.el-input {
  width: 460px;
}
.addButton {
  width: 70px;
  height: 40px;
  position: absolute;
  top: 5px;
  right: 60px;
}
body .el-table::before {
  z-index: inherit;
}
</style>
